import AcademicJobPositions from './AcademicJobPositions.component';

export default AcademicJobPositions;
